import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useParams, useNavigate } from "react-router-dom";
import ProcessDescription from "./components/processDescription";
import AnexosTab from "./components/anexosTab";
import ReuTab from "./components/reuTab";
import AutoresTab from "./components/autoresTab";
import AdvogadosTab from "./components/advogadosTab";
import PagamentosTab from "./components/pagamentosTab";
import WorkflowTab from "./components/workflowTab";
import DocumentosTab from "./components/documentosTab";
import PrazoTab from "./components/prazoTab";
import HistoricoGeral from "./components/historicoGeral";
import UploadModal from "./modal/uploadModal";
import { dataFormato } from "./utils/dateFormato";
import { data } from "jquery";

function Cliente({ response }) {
    const navigate = useNavigate();
    const { id } = useParams();

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [processData, setProcessData] = useState(null);
    const [usuario, setUsuario] = useState(null);
    const [reus, setReus] = useState([]);
    const [autores, setAutores] = useState([]);
    const [advogados, setAdvogados] = useState([]);
    const [pagamentos, setPagamentos] = useState([]);
    const [workflows, setWorkflows] = useState([]);
    const [anexos, setAnexos] = useState([]);
    const [timeline, setTimeline] = useState([]);
    const [prazos, setPrazos] = useState(false);
    const [docs, setDocs] = useState([]);
    const [selectedPaymentId, setSelectedPaymentId] = useState(null);
    const [showUploadModal, setShowUploadModal] = useState(false);

    useEffect(() => {
        if (response.auth === true) {
            setIsAuthenticated(true);
            setProcessData(response.resp);
            setUsuario(response.usuario);
            setReus(response.reus);
            setAutores(response.autores);
            setAdvogados(response.advogados);
            setPagamentos(response.pagamentos);
            setWorkflows(response.workflows);
            setAnexos(response.anexos);
            setTimeline(response.timeline);
            setDocs(response.docs);
        } else {
            navigate("/login");
        }
    }, [response, navigate]);

    useEffect(() => {
        const getPrazos = async () => {
            try {
              const res = await axios.get(`/api/get/deadline/${id}`, {
                withCredentials: true,
              });
      
              console.log(res.data);
              if (res.data) {
                setPrazos(res.data);
              } else {
                alert('Erro ao recuperar prazos');
              }
            } catch (error) {
              console.error('Erro no get de prazos:', error);
            }
        };
      
        getPrazos();
    }, [id])

    if (!isAuthenticated) {
        return (
            <div style={spinnerStyle}>
                <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }

    const handleEditPayment = (paymentId) => {
        setSelectedPaymentId(paymentId);
        setShowUploadModal(true);
    };

    const handleCloseModal = () => {
        setShowUploadModal(false);
        setSelectedPaymentId(null);
    };

    return (
        <>
            <section className="content">
                <div className="container-fluid" style={{ marginTop: 18 }}>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <TabNavigation
                                        atualizarTitulo={atualizarTitulo}
                                    />
                                    <div
                                        className="row"
                                        style={{ marginTop: -1 }}
                                    >
                                        <div className="col-12">
                                            <div className="card-header bg-info">
                                                <h3
                                                    className="text-center"
                                                    id="titulo"
                                                >
                                                    Dados da Requisição
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="tab-content">
                                        <ProcessDescription
                                            processData={processData}
                                            dataFormato={dataFormato}
                                        />
                                        <PrazoTab
                                            responsePrazos={
                                                prazos
                                            }
                                            dataFormato={dataFormato}
                                        />
                                        <AnexosTab
                                            anexos={anexos}
                                            processData={processData}
                                            dataFormato={dataFormato}
                                        />
                                        <PagamentosTab
                                            pagamentos={pagamentos}
                                            money={money}
                                            handleEditPayment={
                                                handleEditPayment
                                            }
                                            dataFormato={dataFormato}
                                        />
                                        <WorkflowTab workflows={workflows} dataFormato={dataFormato}/>
                                        <DocumentosTab docs={docs} id={id} />
                                    </div>
                                    <HistoricoGeral timeline={timeline} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <UploadModal
                show={showUploadModal}
                onClose={handleCloseModal}
                paymentId={selectedPaymentId}
                id={id}
            />
        </>
    );

    // Funções auxiliares

    function money() {
        const total = pagamentos.reduce((acc, resp) => {
            const currency = resp.valor.replace(/\D/g, "");
            const curr = parseFloat(currency) / 100;
            return acc + curr;
        }, 0);

        return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
        }).format(total);
    }

    function atualizarTitulo(titulo) {
        const tituloMap = {
            1: "Dados da Requisição",
            2: "Prazos de comprovantes",
            3: "Anexos Adicionados",
            4: "Pagamentos",
            5: "Workflow",
            6: "Documentos",
        };

        if (tituloMap[titulo]) {
            document.querySelector("#titulo").textContent = tituloMap[titulo];
        } else {
            console.log("Erro! Título inválido.");
        }
    }

    const spinnerStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
    };
}

// Componente de Navegação de Abas
function TabNavigation({ atualizarTitulo }) {
    const abas = [
        { id: 1, label: "Descrição", href: "#primeira-aba", active: true },
        { id: 2, label: "Prazos", href: "#segunda-aba", active: false },
        { id: 3, label: "Anexo", href: "#terceira-aba", active: false },
        { id: 4, label: "Pagamentos", href: "#quarta-aba", active: false },
        { id: 5, label: "Workflow", href: "#quinta-aba", active: false },
        { id: 6, label: "Documentos", href: "#sexta-aba", active: false },
    ];

    return (
        <div className="row">
            <div className="container center-element">
                <ul
                    className="nav nav-tabs nav-tabs-light flex-center"
                    role="tablist"
                >
                    {abas.map((aba) => (
                        <li
                            key={aba.id}
                            role="presentation"
                            className="nav-item"
                            onClick={() => atualizarTitulo(aba.id)}
                        >
                            <a
                                href={aba.href}
                                className={`nav-link ${
                                    aba.active ? "active" : ""
                                }`}
                                aria-controls={aba.href.substring(1)}
                                role="tab"
                                data-toggle="tab"
                                aria-expanded={aba.active ? "true" : "false"}
                            >
                                <span className="hidden-xs hidden-sm">
                                    {aba.label}
                                </span>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default Cliente;
